import React from "react";

import { useReglementInterieurSettings } from "./hooks/useReglementInterieurSettings";

import ReglementHeader from "./components/ReglementHeader";
import ReglementEditorCard from "./components/ReglementEditorCard";
import ReglementImagesCard from "./components/ReglementImagesCard";
import ReglementPreviewCard from "./components/ReglementPreviewCard";

export default function SettingsReglementInterieur() {
  const dashboard = useReglementInterieurSettings();

  const formId = "reglement-interieur-settings-form";

  return (
    <div className="space-y-5">
      <ReglementHeader
        formId={formId}
        loading={dashboard.loading}
        saving={dashboard.saving}
      />

      <ReglementEditorCard
        formId={formId}
        settings={dashboard.settings}
        loading={dashboard.loading}
        saving={dashboard.saving}
        onContentChange={dashboard.handleContentChange}
        onSubmit={dashboard.handleSubmit}
      />

      <ReglementImagesCard
        settings={dashboard.settings}
        loading={dashboard.loading}
        previewUrls={dashboard.previewUrls}
        selectedFiles={dashboard.selectedFiles}
        uploadingTarget={dashboard.uploadingTarget}
        disabledUpload={dashboard.uploading}
        onFileSelect={dashboard.handleFileSelect}
        onFileClear={dashboard.clearSelectedFile}
        onUpload={dashboard.handleUploadImage}
      />

      <ReglementPreviewCard
        settings={dashboard.settings}
        previewUrls={dashboard.previewUrls}
        previewDark={dashboard.previewDark}
        setPreviewDark={dashboard.setPreviewDark}
      />
    </div>
  );
}